import { Component, ElementRef, Input, OnInit } from '@angular/core';
// import { IconService } from 'src/app/services/icon.service';

@Component({
  selector: 'app-svg-icon',
  templateUrl:'./svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
})
export class SvgIconComponent implements OnInit {
  @Input() iconName!: string;
  @Input() iconType!: string;

  constructor() {}

  ngOnInit() {
    // this.iconService.getIcon(this.iconName).subscribe(svg => {
    //   this.el.nativeElement.innerHTML = svg;
    // });
  }
}
